import { render, staticRenderFns } from "./GlobalP.vue?vue&type=template&id=7599ffae&scoped=true&"
import script from "./GlobalP.vue?vue&type=script&lang=js&"
export * from "./GlobalP.vue?vue&type=script&lang=js&"
import style0 from "./GlobalP.vue?vue&type=style&index=0&id=7599ffae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7599ffae",
  null
  
)

export default component.exports